import React, { FunctionComponent, PropsWithChildren } from 'react';

import {
  default as MuiDialogActions,
  DialogActionsProps,
} from '@mui/material/DialogActions';

const DialogActions: FunctionComponent<DialogActionsProps> = (
  props: PropsWithChildren<DialogActionsProps>
) => {
  return <MuiDialogActions {...props}>{props.children}</MuiDialogActions>;
};

export default DialogActions;
